import cityLogo from '../static/assets/City_Select_active.png'
import salesLogo from '../static/assets/Sales_active.png'
import catalogLogo from '../static/assets/Catalog_active.png'
import ajaxsuiteLogo from '../static/assets/Ajax_Suite_active.png'
import customerLogo from '../static/assets/Customer_active.png'
import marketinglogo from '../static/assets/Marketing_active.png'
//import contentLogo from '../static/assets/'
//import plumrocketLogo from '../static/assets/'

const sideMenu = [
  { id : 1, name: 'City Select', source: cityLogo },
  { id: 2, name: 'Sales', source: salesLogo },
  { id: 3, name: 'Catalog', source: catalogLogo },
  { id: 4, name: 'Ajax Suite', source: ajaxsuiteLogo },
  { id: 5, name: 'Customers', source: customerLogo },
  { id: 6, name: 'Marketing', source: marketinglogo},
  { id: 7, name: 'Content', source: ''},
  { id: 8, name: 'Plum Rocket', soutce: salesLogo},
  { id: 9, name: 'Reports', source: salesLogo},
  { id: 10, name: 'Stores', source: salesLogo},
  { id: 11, name: 'Find Partners', source: salesLogo}
]

export default sideMenu